import React from 'react';
import { faqData }  from "../utils/faq-data"

const Faqs = () => {
    return (
      <div className=" bg-gray-200 p-20 container mx-auto px-6 py-8 max-w-5xl">
        {faqData.map((section, index) => (
          <div key={index} className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{section.section}</h2>
            {section.questions.map((faq, idx) => (
              <details
                key={idx}
                className="group border-l-4 border-[#ff9906] bg-gray-100 p-4 mb-4 rounded-md shadow-md [&_summary::-webkit-details-marker]:hidden"
                open={idx === 0} // Open the first FAQ by default in each section
              >
                <summary className="flex cursor-pointer items-center justify-between gap-1.5">
                  <h3 className="text-lg font-medium text-gray-900">{faq.question}</h3>
                  <span className="shrink-0 rounded-full border border-[#ff9906] bg-white p-1.5 text-[#ff9906]">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5 shrink-0 transition duration-300 group-open:-rotate-45"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </span>
                </summary>
                <p className="mt-4 leading-relaxed text-gray-700">{faq.answer}</p>
              </details>
            ))}
          </div>
        ))}
      </div>
    );
};

export default Faqs;